import template from './sort-by.html';
import SortByController from './sort-by.controller';
import './sort-by.less';

const SortByComponent = {
  bindings: {
    sortByFilter: '&',
    showLocationFilter: '<'
  },
  template,
  controller: SortByController
};

export default SortByComponent;



// WEBPACK FOOTER //
// ./src/components/sort-by/sort-by.component.js